export default "__VITE_ASSET__DdDDPo0K__"